export const noop = () => {}
export default noop
